export default __webpack_public_path__ + "static/SupplementBannerDesktop-243820f32c82e1b321621d618f55e57e.jpg";